import styled from 'styled-components';

import DeviceVideo from 'components/DeviceVideo/DeviceVideo';

export const StyledDeviceVideo = styled(DeviceVideo)`
  margin: 0 auto;
`;

StyledDeviceVideo.displayName = 'StyledDeviceVideo';
